<div
  class="credit-display-wrapper flex vcenter"
  routerLink="/user/credits"
>
  @if ((client?.credits?.length ?? 0) === 0) {
    <span>
      {{ "CREDITS.HEADER.TITLE" | translate }}
    </span>
  }
  @for (credit of client?.credits ?? []; track credit.currency_iso; let last = $last) {
    <span
      class="amount"
      [class.no-remaining]="credit.remaining <= 0"
    >
      {{ credit.remaining || 0 | currency: credit.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
    </span>
    @if (!last) {
      <div class="separator">/</div>
    }
  }
</div>
